import { z } from "zod";

export const AwImportIdSchema = z.object({
	aw_import_id: z.string()
});

export type AwImportId = z.infer<typeof AwImportIdSchema>;
